import { Endpoints } from "../../contants/endpoints";
import { api } from "../../lib/api";

export async function getListBanner() {
  try {
    const res = await api.get(Endpoints?.banner?.search);
    if (res.data) {
      return res.data;
    } else {
      return [];
    }
  } catch (error) {
    console.error("API banner list error:", error);
    return [];
  }
}
